import React, { FC } from 'react'

import { TrustIcon } from '@Components/Icons'
import { getMobileNavEvent, IconLink, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconFR: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <IconLink
    event={getMobileNavEvent('trustedshops', variant)}
    href="https://www.trustedshops.fr/evaluation/info_X486286508E1E6A83AF3E43C51929EA24.html"
    rel="noopener noreferrer"
    target="_blank"
    variant={variant}
  >
    <TrustIcon image="frontend/trust-logos/trusted-shops-logo.png" />
  </IconLink>
)
